import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Truck } from 'lucide-react';
import StaffAuthPanel from '../components/auth/StaffAuthPanel';
import { buildCustomerLoginUrl } from '../utils/authReturnUrl';
import { getStorefrontDisplayHost, wsPath } from '../utils/siteHosts';
import { LewouhmartLogoMark } from '../components/branding/LewouhmartLogoMark';

function StaffAuthPage() {
  const [searchParams] = useSearchParams();
  const returnTarget = searchParams.get('returnUrl');

  return (
    <div className="flex min-h-screen flex-col bg-slate-100">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-14 max-w-lg items-center gap-3 px-4 sm:px-6">
          <LewouhmartLogoMark
            brandPrimary="#059669"
            navAccent="#ea580c"
            size={32}
            className="shrink-0"
          />
          <div className="min-w-0">
            <p className="text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-500">
              Workspace
            </p>
            <p className="truncate text-sm font-semibold text-slate-900">Lewouhmart</p>
          </div>
        </div>
      </header>

      <div className="flex flex-1 flex-col items-center justify-center px-4 py-10 sm:px-6">
        <div className="w-full max-w-md">
          <div className="rounded-sm border border-slate-200 bg-white shadow-sm">
            <div className="border-b border-slate-200 px-6 py-5">
              <h1 className="text-lg font-semibold tracking-tight text-slate-900">Staff sign-in</h1>
              <p className="mt-1 text-sm text-slate-600">
                Use your work email to access orders, inventory, and settings.
              </p>
            </div>
            <div className="px-6 py-6">
              <StaffAuthPanel returnTarget={returnTarget} />
            </div>
          </div>

          <div className="mt-6 space-y-2 border-t border-slate-200 pt-5 text-center text-xs text-slate-500">
            <p>
              <Link
                to={wsPath('/auth/agent')}
                className="inline-flex items-center gap-1.5 font-medium text-slate-700 hover:text-slate-900"
              >
                <Truck className="h-3.5 w-3.5" strokeWidth={2.25} />
                Shipping agent sign-in
              </Link>
            </p>
            <p>
              Customer account?{' '}
              <a
                href={buildCustomerLoginUrl('/')}
                className="font-medium text-slate-900 underline underline-offset-2"
              >
                {getStorefrontDisplayHost()}
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StaffAuthPage;
